<template>
	<div class="tab-list">
		<div class="row row-item">
			<div class="col-5"><p class="heading-p">{{getString('price_symbol', [currencyStore.currCurrency.symbol])}}</p></div>
			<div class="col-7">
				<div class="row">
					<div class="col-3">
						<p>0</p>
						<p class="small">{{ getString("free_plan") }}</p>
					</div>
					<div class="col-3">
						<p>{{ currentPrices[0] }}</p>
						<p class="small">{{ getString("basic_plan") }}</p>
					</div>
					<div class="col-3">
						<p>{{ currentPrices[1] }}</p>
						<p class="small">{{ getString("pro_plan") }}</p>
					</div>
					<div class="col-3">
						<p>{{ currentPrices[2] }}</p>
						<p class="small">{{ getString("allinone_plan") }}</p>
					</div>
				</div>
			</div>
		</div>

		<div v-for="(breakdownItem, bdIndex) in breakdownItems" :key="bdIndex" :class="{'sticky-heading': breakdownItem.heading}" class="row row-item">
			<div v-if="!breakdownItem.heading" class="col-5">
				<p v-html="breakdownItem.name"></p>
			</div>
			<div v-if="!breakdownItem.heading" class="col-7">
				<div class="row">
					<div v-for="(colKey, colIndex) in 4" class="col-3">
						<p class="small" v-if="breakdownItem?.overlines?.[colIndex]" v-html="breakdownItem?.overlines?.[colIndex]"></p>
						<img v-if="breakdownItem.values[colIndex] === 'v'" src="https://img.qromo.io/img/web-site/new/icon-rounded-ok.svg" alt="check">
						<img v-else-if="breakdownItem.values[colIndex] === 'x'" src="https://img.qromo.io/img/web-site/new/icon-decline.svg" alt="check">
						<img v-else-if="breakdownItem.values[colIndex] === '+'" src="https://img.qromo.io/img/web-site/new/icon-plus-oval.svg" alt="add-on">
						<p v-else v-html="breakdownItem.values[colIndex]"></p>
						<p class="small" v-if="breakdownItem?.subtitles?.[colIndex]" v-html="breakdownItem?.subtitles?.[colIndex]"></p>
					</div>
				</div>
			</div>
			<p v-if="breakdownItem.heading">{{breakdownItem.name}}</p>
		</div>
	</div>
</template>

<script>
import {useLanguageStore, useCurrencyStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
	name: "PlansComparisonList",
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const currencyStore = useCurrencyStore();
		return { userStore, currencyStore, languageStore, getString: languageStore.getString };
	},
	data() {
		return {

		}
	},
	computed: {
		currentPrices() {
			let prices = this.currencyStore.currCurrency?.prices?.plans;
			if(prices) {
				return [
					this.currencyStore.readableCurrencyValue(prices?.basic?.yearMonth, false, false, true),
					this.currencyStore.readableCurrencyValue(prices?.pro?.yearMonth, false, false, true),
					this.currencyStore.readableCurrencyValue(prices?.allinone?.yearMonth, false, false, true)
				];
			}
			return [0,0,0];
		},
		breakdownItems() {
			let featureCategory1 = [
				{
					heading: true,
					name: this.getString('title_category_1'),
				},
				{
					name: this.getString('functionality_tab_1'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_3'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_5'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_2'),
					values: ['x', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_4'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_6'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_7'),
					values: ['x', 'x', 'x', 'v']
				},
				{
					name: this.getString('functionality_tab_8'),
					values: ['x', 'x', 'x', 'v']
				},
			]
			let featureCategory2 = [
				{
					heading: true,
					name: this.getString('title_category_2'),
				},
				{
					name: this.getString('functionality_tab_9'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_10'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_11'),
					values: ['1', '3', '10', '∞']
				},
			]
			let featureCategory3 = [
				{
					heading: true,
					name: this.getString('title_category_3'),
				},
				{
					name: this.getString('functionality_tab_12'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_13'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_14'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_15'),
					values: ['x', 'x', '+', '+']
				},
			]
			let featureCategory4 = [
				{
					heading: true,
					name: this.getString('title_category_4'),
				},
				{
					name: this.getString('functionality_tab_16'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_17'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_18'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_19'),
					values: ['x', 'x', 'v', 'v']
				},
			]
			let featureCategory5 = [
				{
					heading: true,
					name: this.getString('title_category_5'),
				},
				{
					name: this.getString('functionality_tab_20'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_21'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_22'),
					values: ['x', 'x', 'v', 'v']
				},
			]
			let featureCategory6 = [
				{
					heading: true,
					name: this.getString('title_category_6'),
				},
				{
					name: this.getString('functionality_tab_23'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_24'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_25'),
					values: ['x', 'x', '1', '1']
				},
				{
					name: this.getString('functionality_tab_26'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_27'),
					values: ['x','x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_28'),
					values: ['x', 'x', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_29'),
					values: ['x', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_30'),
					values: ['x', 'v', 'v', 'v']
				},
			]
			let featureCategory7 = [
				{
					heading: true,
					name: this.getString('title_category_7'),
				},
				{
					name: this.getString('functionality_tab_31'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_32'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_33'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_34'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_35'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_36'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_37'),
					values: ['v', 'v', 'v', 'v']
				},
				{
					name: this.getString('functionality_tab_38'),
					values: ['v', 'v', 'v', 'v']
				}
			]
			let featureCategory8 = [
				{
					heading: true,
					name: this.getString('title_category_8'),
				},
				{
					name: this.getString('functionality_tab_39'),
					values: ['v', 'v', 'v', 'v']
				}
			]
			let featureCategory9 = [
				{
					heading: true,
					name: this.getString('title_category_9'),
				},
				{
					name: this.getString('functionality_tab_40'),
					values: ['+', '+', '+', '+']
				},
				{
					name: this.getString('functionality_tab_41'),
					values: ['+', '+', '+', '+']
				},
				{
					name: this.getString('functionality_tab_42'),
					values: ['+', '+', '+', '+']
				},
				{
					name: this.getString('functionality_tab_43'),
					values: ['+', '+', '+', '+']
				}
			]
			let formattedTapToPayFee = this.currencyStore.readableCurrencyValue(this.currencyStore.currCurrency.tap_to_pay_fee);
			let maxCashAmountFormatted = this.currencyStore.readableCurrencyValue(this.currencyStore.currCurrency.max_free_weekly_cash_amount, true, true, true);
			let featureCategory10 = [
				{
					heading: true,
					name: this.getString('title_category_10'),
				},
				{
					name: this.getString('functionality_tab_44'),
					values: [this.localePercent(2), this.localePercent(1.6), this.localePercent(1.4), this.localePercent(1.2)]
				},
				{
					name: this.getString('functionality_tab_45'),
					values: ['+'+this.localePercent(1,0), '+'+this.localePercent(1,0), '+'+this.localePercent(1,0), '+'+this.localePercent(1,0)],
					subtitles: [this.getString('functionality_fee_subtitle'), this.getString('functionality_fee_subtitle'), this.getString('functionality_fee_subtitle'), this.getString('functionality_fee_subtitle')]
				},
				{
					name: this.getString('functionality_tab_46'),
					values: ['+'+formattedTapToPayFee, '+'+formattedTapToPayFee, '+'+formattedTapToPayFee, '+'+formattedTapToPayFee],
					overlines: [this.getString('functionality_base_fee'), this.getString('functionality_base_fee'), this.getString('functionality_base_fee'), this.getString('functionality_base_fee')]
				},
				{
					name: this.getString('functionality_tab_51'),
					values: ['', '∞', '∞', '∞'],
					overlines: [this.getString('x_per_week', [maxCashAmountFormatted]), '', '', '']
				},
				{
					name: this.getString('functionality_tab_52'),
					values: ['∞', '∞', '∞', '∞']
				},
				{
					name: this.getString('functionality_tab_53'),
					values: ['x', '∞', '∞', '∞']
				},
			]
			let formattedFixedFee = this.currencyStore.readableCurrencyValue(this.currencyStore.currCurrency.fixed_fee);
			let featureCategory11 = [
				{
					heading: true,
					name: this.getString('title_category_11'),
				},
				{
					name: this.getString('functionality_tab_47'),
					values: ['x', 'x', this.localePercent(1.99, 2), this.localePercent(1.99, 2)],
					subtitles: ['', '', '+ '+formattedFixedFee, '+ '+formattedFixedFee],
				},
				{
					name: this.getString('functionality_tab_48'),
					values: ['x', 'x', '1%', '1%'],
				},
				{
					name: this.getString('functionality_tab_49'),
					values: ['x', 'x', '+'+this.localePercent(6,0), '+'+this.localePercent(6,0)],
                    subtitles: ['', '', this.getString('functionality_fee_subtitle'), this.getString('functionality_fee_subtitle')]
                },
				{
					name: this.getString('functionality_tab_50'),
                    values: ['x', 'x', this.localePercent(1,0), this.localePercent(1,0)],
                },
				{
					name: this.getString('payment_type_satispay'),
					values: ['x', 'x', this.localePercent(1,0), this.localePercent(1,0)],
				},
			]
			return [
				...featureCategory1,
				...featureCategory2,
				...featureCategory10,
				...featureCategory11,
				...featureCategory3,
				...featureCategory4,
				...featureCategory5,
				...featureCategory6,
				...featureCategory7,
				...featureCategory8,
				...featureCategory9,
			];
		}
	},
	methods: {
		localeNum(value, fractionDigits = 1, appendSymbol = '') {
			return Number(value || 0).toLocaleString([this.languageStore.lang || 'en'], { minimumFractionDigits: fractionDigits }) + appendSymbol;
		},
		localePercent(value, fractionDigits = 1) {
			return this.localeNum(value, fractionDigits, '%');
		}
	}
}

</script>

<style scoped lang="scss">
.tab-list {
	width: 100%;
	border-radius: 13px;
	border: 1px solid var(--color-bg-1);
	overflow: scroll;
	.row {
		&.row-item {
			align-items: stretch;
			border-bottom: 1px solid var(--color-bg-primary-3);
			text-align: center;

			&:first-child {
				position: sticky;
				top: 0;
				background-color: var(--color-manual-4);
				height: 71.5px;

				p.heading-p {
					color: var(--color-txt-white);
				}

				.col-7 {
					border-left: 1px solid var(--color-bg-primary-3);
					.col-3 {
						border-right: 1px solid var(--color-bg-primary-3);
						padding: 8px 2px;
						p {
							color: var(--color-txt-white);
							font-weight: 700;
							line-height: 26px;
							font-size: 26px;
							text-align: center;
							span, &.small {
								color: var(--color-txt-white);
								font-size: 14px;
								line-height: 16px;
								font-weight: 400;
								margin-top: 8px;
							}
						}
					}
				}
			}
			&:last-child {
				border-bottom: none;
			}
			&:nth-child(even) {
				background-color: var(--color-alpha-dropdown-1);
			}
			.col-5 {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 3px 10px;
				min-height: 35px;
				p {
					font-size: 18px;
					line-height: normal;
				}
			}
			.col-7 {
				border-left: 1px solid var(--color-bg-primary-3);
				display: flex;
				.col-3 {
					display: flex;
					justify-content: center;
					align-items: center;
					border-right: 1px solid var(--color-bg-primary-3);
					padding: 3px;
					p {
						font-size: 18px;
						font-weight: 400;
						line-height: 22px;
						text-align: center;

						span, &.small {
							font-size: 14px;
							line-height: 16px;
						}
					}
					img {
						height: 18px;
						width: 18px;
					}
					&:last-child {
						border-right: none;
					}
				}

				&>.row {
					height: 100%;
				}
			}

			&.sticky-heading {
				position: sticky;
				top: 71.5px;
				background-color: var(--color-manual-4);
				padding: 0 10px;
				p {
					font-size: 16px;
					color: var(--color-txt-white);
					padding: 10px 0;
					font-weight: bold;
				}
			}
		}
	}

	@media (max-width: 600px) {

		.row.row-item .col-5 p {
			font-size: 14px;
		}
		.row.row-item .col-7 .col-3 {
			padding: 8px 0;
			p {
				font-size: 14px;
				line-height: 14px;

				span, &.small {
					font-size: 12px;
					line-height: 14px;
				}
			}
		}
		.row.row-item .col-7 .col-3 p {
			font-size: 12px;
			line-height: 14px;

			span, &.small {
				font-size: 10px;
				line-height: 12px;
			}
		}
		.row.row-item:first-child .col-7 .col-3 {
			padding: 8px 0;

			p {
				font-size: 20px;
				line-height: 20px;

				span, &.small {
					font-size: 12px;
					line-height: 14px;
				}
			}
		}
	}

	@media (max-width: 460px) {
		.row.row-item:first-child .col-7 .col-3 p {
			span, &.small {
				font-size: 10px;
				line-height: 12px;
			}
		}
	}

	@media (max-width: 365px) {
		.row.row-item:first-child .col-7 .col-3 p {
			span, &.small {
				font-size: 8px;
				line-height: 10px;
			}
		}
	}
}
</style>